import React from 'react';
import { CardLegacy, makeStyles, GRAY } from '@applyboard/ui-components';
import { CEF_CARD_WIDTH } from "../Common/Constants";
var useStyles = makeStyles({
  root: {
    padding: '0px !important',
    width: CEF_CARD_WIDTH,
    background: GRAY[21],
    margin: function margin(props) {
      return props.onboarding ? null : '120px 0';
    }
  }
});
var CefCard = function CefCard(_ref) {
  var children = _ref.children,
    _ref$onboarding = _ref.onboarding,
    onboarding = _ref$onboarding === void 0 ? false : _ref$onboarding;
  var classes = useStyles({
    onboarding: onboarding
  });
  return (
    /*#__PURE__*/
    // @ts-except -- TODO: replace with new Card
    React.createElement(CardLegacy, {
      className: classes.root,
      variant: "elevated"
    }, children)
  );
};
export default CefCard;